<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        企业信用排行
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.beginTime">
            <el-date-picker
              v-model="slotForms.forms.beginTime"
              type="date"
              value-format="timestamp"
              placeholder="选择开始日期"
              :picker-options="bTimePickerOptions"
              @change="selectbTime"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.endTime">
            <el-date-picker
              v-model="slotForms.forms.endTime"
              type="date"
              value-format="timestamp"
              placeholder="选择结束日期"
              :picker-options="eTimePickerOptions"
              @change="selecteTime"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.comparyId">
            <el-select
              v-model="slotForms.forms.comparyId"
              placeholder="企业名称"
              filterable
              clearable
            >
              <el-option
                v-for="item in allComparys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        border
        height="100%"
        @sort-change="handleSortChange"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          v-for="(item, index) in tableColumns"
          header-align="center"
          :key="item.comparyName + '-' + index"
          :prop="item.columCode"
          :label="item.columName"
          align="center"
          :fixed="item.fiexd"
          :sortable="item.sorted"
          min-width="220"
        >
        </el-table-column>
        <el-table-column align="center" label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <router-link
              :to="{
                path: '/comparyCreditDetailList',
                query: {
                  id: scope.row.comparyId,
                  bTime: formExtend.forms.beginTime,
                  eTime: formExtend.forms.endTime
                }
              }"
              style="color:#0099FF"
              >查看
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
  </div>
</template>

<script>
import { FetchFindByPage, FetchTableColumn } from "@/api/comparyCredit/order";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import { FetchAllComparys } from "_private/api/systemSetting/userManage";
import { mergeFormExtend } from "_private/utils/merge";

export default {
  mixins: [resizeListener],
  data() {
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      allComparys: [], //所有企业名称
      formExtend: {
        forms: {
          comparyId: "", //企业名称id
          beginTime:
            new Date(new Date(new Date().toLocaleDateString()).getTime()) -
            (new Date().getDay() + 6) * 24 * 60 * 60 * 1000, //查询时间范围
          endTime:
            new Date(new Date(new Date().toLocaleDateString()).getTime()) -
            new Date().getDay() * 24 * 60 * 60 * 1000,
          sortColumnName: "", //排序列名code
          sortType: 1 //排序方式 1-正序 2-倒序
        },
        extends: []
      },
      //开始时间只让选本周之前的周一
      bTimePickerOptions: {
        disabledDate(time) {
          let lastSunday =
            new Date().getTime() - new Date().getDay() * 24 * 60 * 60 * 1000;
          return time.getTime() > lastSunday || time.getDay() !== 1;
        }
      },
      //结束时间只让选本周之前的周日
      eTimePickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date().getTime() || time.getDay() !== 0;
        }
      },
      formsExtend: [],
      tableColumns: [], //表头数据
      tableData: [], //表格数据
      loading: "false"
    };
  },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"]),
    ids() {
      let ids = this.multipleSelection.map(item => {
        return item.id;
      });
      return ids.length < 1 ? "" : ids.join(",");
    },
    columnStr() {
      let columnStr = this.copyShowTableCols.map(item => {
        return item.name;
      });
      return columnStr.length < 1 ? "" : columnStr.join(",");
    }
  },
  created() {
    this.initAllComparys();
    this.FetchTableColumn();
    this.FetchFindByPage(this.mergeObj());
    // this.FetchGetTableColumnSettings({
    //   moduleId: this.moduleId,
    //   userId: this.userId
    // });
    // this.setSearchFormIsOpenAct();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),

    /**
     *  初始化企业
     */
    initAllComparys() {
      FetchAllComparys()
        .then(response => {
          if (
            response.result &&
            response.result &&
            Array.isArray(response.result)
          ) {
            this.allComparys = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取表格数据
    FetchFindByPage(response) {
      this.loading = true;
      this.tableData = [];
      FetchFindByPage(response)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 获取表格列头
    FetchTableColumn(response) {
      FetchTableColumn(response)
        .then(response => {
          if (
            response.code === 1 &&
            response.result &&
            Array.isArray(response.result)
          ) {
            let tableCol = response.result;
            tableCol.forEach(item => {
              if (item.sorted) {
                item.sorted = "custom";
              }
            });
            this.tableColumns = tableCol;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //选择了周一，结束时间自动选择该周天
    selectbTime(val) {
      if (val) {
        this.formExtend.forms.endTime = val + 6 * 24 * 60 * 60 * 1000;
      } else {
        this.formExtend.forms.endTime = val;
      }
    },
    //选择了周天，开始时间自动选择该周一
    selecteTime(val) {
      if (val) {
        this.formExtend.forms.beginTime = val - 6 * 24 * 60 * 60 * 1000;
      } else {
        this.formExtend.forms.beginTime = val;
      }
    },
    //表格排序
    handleSortChange({ prop, order }) {
      if (order === "ascending") {
        this.formExtend.forms.sortColumnName = prop;
        this.formExtend.forms.sortType = 1;
      } else if (order === "descending") {
        this.formExtend.forms.sortColumnName = prop;
        this.formExtend.forms.sortType = 2;
      } else {
        this.formExtend.forms.sortColumnName = "";
        this.formExtend.forms.sortType = 2;
      }
      this.FetchFindByPage(this.mergeObj()); // 刷新表格数据
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize
        }
      });
    },
    // 是否展开查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 点击查询按钮查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 选择表格列
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },

    // 取消表格列设置
    handleSetColumnCancel() {
      this.copyShowTableCols = this.showTableCols;
      this.copyHideTableCols = this.hideTableCols;
    },
    // 确认表格列设置
    handleSetColumnSubmit() {
      this.FetchSaveUserTableColumnSettings({
        moduleId: this.moduleId,
        userId: this.userId,
        columnStr: this.columnStr
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.nodata {
  color: #999;
  font-size: 18px;
  text-align: center;
  margin-top: 270px;
}
</style>
